module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-lock-fill-2dd72f97.svg";